import { getEnvironmentFromHost } from '../api/endpoints';
import { ClubCode, envMapForJoinUrl } from './constants';
import { getClubContent, ClubContentName } from '../utils/getClubContent';
import CookieHelper from './cookieHelper';

export const generateJoinURL = (clubcode: string, zipcodeentry: string, campaigncode?: any) => {
  const env = getEnvironmentFromHost(window.location.hostname);
  const joinEnv = envMapForJoinUrl[env] || 'apps';
  const clubCode = clubcode ? clubcode : CookieHelper.getClubCodeFromZipcodeCookie() || '';
  const zipCode = zipcodeentry ? zipcodeentry : CookieHelper.getZipcodeFromZipcodeCookie() || '';
  const club =
    getClubContent(ClubContentName.CodeClubUrl, clubCode) ||
    getClubContent(ClubContentName.CodeClubUrl, ClubCode.calif);
  let url = `https://${joinEnv}.${club}.aaa.com/aceapps/membership/JoinNow/Start?flowName=NewBiz&clubcode=${clubCode}&zipcodeentry=${zipCode}`;

  if (campaigncode) {
    url += `&campaigncode=${campaigncode}`;
  }

  return url;
};
